var map = {
	"./BIO_RED.png": "406c",
	"./FOLDESIGN.png": "b55d",
	"./IASA.png": "de40",
	"./MEDITECH.png": "7da2",
	"./PIMAX.png": "4f5f",
	"./RX_OLIVOS.png": "b093",
	"./VOXEL.png": "abe4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e50f";